import "./loading.css";

export const Loading = () => {
  return (
    <div className="loading-bg">
      <div className="neoverce-loading-wrapper">
        <svg
          width="150"
          height="150"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="neoverce-logo-svg"
        >
          <path
            d="M124.076 369.758V109.523L387.219 372.666H312.515L175.561 235.712V324.435L124.076 369.758Z"
            className="stroke-dark"
          />
          <path
            d="M387.219 80.9082V341.142L124.076 78H198.78L335.733 214.954V126.221L387.219 80.9082Z"
            className="stroke-orange"
          />
        </svg>
      </div>
    </div>
  );
};
